import { RootState } from '../../interfaces/rootState';

export const ErrorStatusSelector = (state: RootState) => state.errorStatus;
